import React from "react";
import styled from "styled-components";
import { PaletteConfiguration } from "../../util/ThemeUtil";

type StyleProps = {
  palette: PaletteConfiguration;
};

const Container = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid ${(props) => props.palette?.infoText};
  width: 100%;
  font-size: 2rem;
  background: ${(props) => props.palette?.background};
  color: ${(props) => props.palette?.infoText};
`;

const Label = styled.div<StyleProps>`
  font-weight: bold;
  background: ${(props) => props.palette?.background};
  color: ${(props) => props.palette?.infoText};
  height: 100%;
  min-height: 50px;
`;

const Value = styled.div<StyleProps>`
  font-weight: normal;
  background: ${(props) => props.palette?.background};
  color: ${(props) => props.palette?.infoText};
  height: 100%;
  min-height: 50px;
`;

type SlimItemProps = {
  label: string;
  value: any;
  palette: PaletteConfiguration;
};

const SlimItem: React.FC<SlimItemProps> = ({ label, value, palette }) => {
  return (
    <Container palette={palette}>
      <Label palette={palette}>{label}</Label>
      <Value palette={palette}>{value ? value : ""}</Value>
    </Container>
  );
};

export default SlimItem;
